module.exports = __webpack_public_path__ + "static/books-f5e2b189f093f7e1e533f8e291b43a8c.jpg";